import React, { useState, useEffect, Suspense } from "react"
import {
  // BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation, // Import useLocation
} from "react-router-dom"
import { ThemeProvider } from "styled-components"

import routes, { routesConfig } from "./routes"
import useThemeStore from "./theme/useThemeStore"
import { GlobalStyle } from "./theme"

import AppLayout from "../components/layout/AppLayout"
import { ScrollToTop } from "../components/utils/scrollToTop"

import CookiePopup from "@components/base/CookieConsent"
import Header from "@pages/website/Common/Header"
import LanguageWrapper from "@utils/language/LanguageWrapper.client"
import Footer from "@pages/website/Common/Footer"
import useScrollPosition from "@hooks/useScrollPosition"
import { PageTransition } from "@components/navigation/PageTransition"
import { AnimatedOutlet } from "@components/navigation/PageTransition/AnimatedOutlet"
import { AnimatePresence, motion } from "framer-motion"
import AnalyticsMount from "@features/analytics/AnalyticsMount"

// Define the type for language keys explicitly
type LanguageKey = "en" | "fr" | "es"

export interface AppProps {
  isAuthenticated: boolean
  url: string
  // Optionally pass a custom Router component (e.g. StaticRouter for SSR)
  Router?: React.ComponentType<{ children: React.ReactNode }>
  // Optionally pass router-specific props (for SSR, e.g., location, context)
  routerProps?: Record<string, unknown>
}

export const variants = {
  initial: { x: "100%", opacity: 0 }, // new page starts off to the right
  animate: { x: "0%", opacity: 1 }, // slides into place
  exit: { x: "100%", opacity: 0 }, // old page slides left
}
export const transition = { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }

export const App: React.FC<AppProps> = ({
  isAuthenticated,
  // url,
  // Router = BrowserRouter,
  // routerProps = {},
}) => {
  const { theme } = useThemeStore()
  const location = useLocation() // Get current location
  const scrollPosition = useScrollPosition() // Get scroll position

  // Determine header style based ONLY on scroll position
  const isScrolled = scrollPosition > 550 // Adjust threshold as needed
  const headerMode = isScrolled ? "solid" : "transparent"

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <AnalyticsMount />
      <CookiePopup />
      <ScrollToTop />
      <Header mode={headerMode} /> {/* Pass the mode to the Header */}
      <AppLayout>
        <AnimatePresence
          mode="wait" // Ensure exit animation completes before enter
        >
          <Suspense fallback={null}>
            <Routes location={location} key={location.pathname}>
              {/* <Route element={<AnimatedOutlet />}> */}
              <Route path="/" element={<Navigate to="/en" replace />} />
              <Route path="/:lang" element={<LanguageWrapper />}>
                {routesConfig.map((route) => {
                  if (route.key === "home") {
                    return <Route index key={`${route.key}-index`} element={route.element} />
                  }
                  const currentLang = (location.pathname.split("/")[1] || "en") as LanguageKey // Assert type
                  const pathSlug = route.paths[currentLang] || route.paths["en"] // Use asserted type
                  return <Route key={`${route.key}-route`} path={pathSlug} element={route.element} />
                })}
              </Route>
              {/* </Route> */}
            </Routes>
            <Footer />
          </Suspense>
        </AnimatePresence>
      </AppLayout>
      {/* </Router> */}
    </ThemeProvider>
  )
}

export default App
